var __create = Object.create;
var __defProp = Object.defineProperty;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
var __commonJS = (callback, module) => () => {
  if (!module) {
    module = {exports: {}};
    callback(module.exports, module);
  }
  return module.exports;
};
var __exportStar = (target, module, desc) => {
  if (module && typeof module === "object" || typeof module === "function") {
    for (let key of __getOwnPropNames(module))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, {get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable});
  }
  return target;
};
var __toModule = (module) => {
  return __exportStar(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? {get: () => module.default, enumerable: true} : {value: module, enumerable: true})), module);
};

// node_modules/lodash.throttle/index.js
var require_lodash = __commonJS((exports, module) => {
  var FUNC_ERROR_TEXT = "Expected a function";
  var NAN = 0 / 0;
  var symbolTag = "[object Symbol]";
  var reTrim = /^\s+|\s+$/g;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var objectProto = Object.prototype;
  var objectToString = objectProto.toString;
  var nativeMax = Math.max;
  var nativeMin = Math.min;
  var now = function() {
    return root.Date.now();
  };
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
      return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result : trailingEdge(now());
    }
    function debounced() {
      var time = now(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  function throttle2(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    if (isObject(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
      leading,
      maxWait: wait,
      trailing
    });
  }
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  module.exports = throttle2;
});

// node_modules/spark-md5/spark-md5.js
var require_spark_md5 = __commonJS((exports, module) => {
  (function(factory) {
    if (typeof exports === "object") {
      module.exports = factory();
    } else if (typeof define === "function" && define.amd) {
      define(factory);
    } else {
      var glob;
      try {
        glob = window;
      } catch (e) {
        glob = self;
      }
      glob.SparkMD5 = factory();
    }
  })(function(undefined2) {
    "use strict";
    var add32 = function(a, b) {
      return a + b & 4294967295;
    }, hex_chr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function cmn(q, a, b, x, s, t) {
      a = add32(add32(a, q), add32(x, t));
      return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
      var a = x[0], b = x[1], c = x[2], d = x[3];
      a += (b & c | ~b & d) + k[0] - 680876936 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[1] - 389564586 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[2] + 606105819 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[4] - 176418897 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[7] - 45705983 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[10] - 42063 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[13] - 40341101 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & d | c & ~d) + k[1] - 165796510 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[11] + 643717713 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[0] - 373897302 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[5] - 701558691 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[10] + 38016083 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[15] - 660478335 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[4] - 405537848 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[9] + 568446438 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[3] - 187363961 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[2] - 51403784 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b ^ c ^ d) + k[5] - 378558 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[14] - 35309556 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[7] - 155497632 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[13] + 681279174 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[0] - 358537222 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[3] - 722521979 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[6] + 76029189 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[9] - 640364487 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[12] - 421815835 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[15] + 530742520 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[2] - 995338651 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      x[0] = a + x[0] | 0;
      x[1] = b + x[1] | 0;
      x[2] = c + x[2] | 0;
      x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
      var md5blks = [], i;
      for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }
    function md5blk_array(a) {
      var md5blks = [], i;
      for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
      }
      return md5blks;
    }
    function md51(s) {
      var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i, length, tail, tmp, lo, hi;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
      }
      s = s.substring(i - 64);
      length = s.length;
      tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
      }
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = n * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(state, tail);
      return state;
    }
    function md51_array(a) {
      var n = a.length, state = [1732584193, -271733879, -1732584194, 271733878], i, length, tail, tmp, lo, hi;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
      }
      a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
      length = a.length;
      tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= a[i] << (i % 4 << 3);
      }
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = n * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(state, tail);
      return state;
    }
    function rhex(n) {
      var s = "", j;
      for (j = 0; j < 4; j += 1) {
        s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
      }
      return s;
    }
    function hex(x) {
      var i;
      for (i = 0; i < x.length; i += 1) {
        x[i] = rhex(x[i]);
      }
      return x.join("");
    }
    if (hex(md51("hello")) !== "5d41402abc4b2a76b9719d911017c592") {
      add32 = function(x, y) {
        var lsw = (x & 65535) + (y & 65535), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
      };
    }
    if (typeof ArrayBuffer !== "undefined" && !ArrayBuffer.prototype.slice) {
      (function() {
        function clamp(val, length) {
          val = val | 0 || 0;
          if (val < 0) {
            return Math.max(val + length, 0);
          }
          return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
          var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
          if (to !== undefined2) {
            end = clamp(to, length);
          }
          if (begin > end) {
            return new ArrayBuffer(0);
          }
          num = end - begin;
          target = new ArrayBuffer(num);
          targetArray = new Uint8Array(target);
          sourceArray = new Uint8Array(this, begin, num);
          targetArray.set(sourceArray);
          return target;
        };
      })();
    }
    function toUtf8(str) {
      if (/[\u0080-\uFFFF]/.test(str)) {
        str = unescape(encodeURIComponent(str));
      }
      return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
      var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
      for (i = 0; i < length; i += 1) {
        arr[i] = str.charCodeAt(i);
      }
      return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
      return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
      var result = new Uint8Array(first.byteLength + second.byteLength);
      result.set(new Uint8Array(first));
      result.set(new Uint8Array(second), first.byteLength);
      return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex2) {
      var bytes = [], length = hex2.length, x;
      for (x = 0; x < length - 1; x += 2) {
        bytes.push(parseInt(hex2.substr(x, 2), 16));
      }
      return String.fromCharCode.apply(String, bytes);
    }
    function SparkMD52() {
      this.reset();
    }
    SparkMD52.prototype.append = function(str) {
      this.appendBinary(toUtf8(str));
      return this;
    };
    SparkMD52.prototype.appendBinary = function(contents) {
      this._buff += contents;
      this._length += contents.length;
      var length = this._buff.length, i;
      for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
      }
      this._buff = this._buff.substring(i - 64);
      return this;
    };
    SparkMD52.prototype.end = function(raw) {
      var buff = this._buff, length = buff.length, i, tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ret;
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
      }
      this._finish(tail, length);
      ret = hex(this._hash);
      if (raw) {
        ret = hexToBinaryString(ret);
      }
      this.reset();
      return ret;
    };
    SparkMD52.prototype.reset = function() {
      this._buff = "";
      this._length = 0;
      this._hash = [1732584193, -271733879, -1732584194, 271733878];
      return this;
    };
    SparkMD52.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    };
    SparkMD52.prototype.setState = function(state) {
      this._buff = state.buff;
      this._length = state.length;
      this._hash = state.hash;
      return this;
    };
    SparkMD52.prototype.destroy = function() {
      delete this._hash;
      delete this._buff;
      delete this._length;
    };
    SparkMD52.prototype._finish = function(tail, length) {
      var i = length, tmp, lo, hi;
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(this._hash, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = this._length * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(this._hash, tail);
    };
    SparkMD52.hash = function(str, raw) {
      return SparkMD52.hashBinary(toUtf8(str), raw);
    };
    SparkMD52.hashBinary = function(content, raw) {
      var hash = md51(content), ret = hex(hash);
      return raw ? hexToBinaryString(ret) : ret;
    };
    SparkMD52.ArrayBuffer = function() {
      this.reset();
    };
    SparkMD52.ArrayBuffer.prototype.append = function(arr) {
      var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
      this._length += arr.byteLength;
      for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
      }
      this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
      return this;
    };
    SparkMD52.ArrayBuffer.prototype.end = function(raw) {
      var buff = this._buff, length = buff.length, tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], i, ret;
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff[i] << (i % 4 << 3);
      }
      this._finish(tail, length);
      ret = hex(this._hash);
      if (raw) {
        ret = hexToBinaryString(ret);
      }
      this.reset();
      return ret;
    };
    SparkMD52.ArrayBuffer.prototype.reset = function() {
      this._buff = new Uint8Array(0);
      this._length = 0;
      this._hash = [1732584193, -271733879, -1732584194, 271733878];
      return this;
    };
    SparkMD52.ArrayBuffer.prototype.getState = function() {
      var state = SparkMD52.prototype.getState.call(this);
      state.buff = arrayBuffer2Utf8Str(state.buff);
      return state;
    };
    SparkMD52.ArrayBuffer.prototype.setState = function(state) {
      state.buff = utf8Str2ArrayBuffer(state.buff, true);
      return SparkMD52.prototype.setState.call(this, state);
    };
    SparkMD52.ArrayBuffer.prototype.destroy = SparkMD52.prototype.destroy;
    SparkMD52.ArrayBuffer.prototype._finish = SparkMD52.prototype._finish;
    SparkMD52.ArrayBuffer.hash = function(arr, raw) {
      var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
      return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD52;
  });
});

// src/wt-storm-client/cancel-token.ts
var import_lodash = __toModule(require_lodash());
var FlowState;
(function(FlowState2) {
  FlowState2[FlowState2["ARMED"] = 0] = "ARMED";
  FlowState2[FlowState2["PAUSED"] = 1] = "PAUSED";
  FlowState2[FlowState2["CANCELED"] = 2] = "CANCELED";
})(FlowState || (FlowState = {}));
var CancelToken = class {
  constructor() {
    this.state = 0;
  }
  get canceledOrPaused() {
    return this.state !== 0;
  }
  async waitUntilResumed() {
    return new Promise((resolve) => {
      const isPaused = (0, import_lodash.default)(() => {
        if (this.state !== 1) {
          return resolve(true);
        }
        isPaused();
      }, 2e3);
      if (this.state === 1) {
        isPaused();
      } else {
        resolve(true);
      }
    });
  }
  get canceled() {
    return this.state === 2;
  }
  resume() {
    this.state = 0;
  }
  pause() {
    this.state = 1;
  }
  cancel() {
    this.state = 2;
  }
  throwIfCanceled() {
    if (this.state === 2) {
      throw new Error("Canceled via token");
    }
  }
};

// src/wt-storm-client/utils.ts
function sum(array) {
  return array.reduce((total, v) => total + v, 0);
}
function divmod(number, divisor) {
  const quotient = Math.floor(number / divisor);
  const remainder = number % divisor;
  return [quotient, remainder];
}
function stringifyEvent(event) {
  const obj = {};
  for (let k in event) {
    obj[k] = event[k];
  }
  try {
    let seen = [];
    return JSON.stringify(obj, function(key, val) {
      if (val != null && val instanceof Node)
        return "Node";
      if (val != null && val instanceof Window)
        return "Window";
      if (val != null && typeof val == "object") {
        if (seen.indexOf(val) >= 0) {
          return;
        }
        seen.push(val);
      }
      return val;
    }, "");
  } catch {
    return "";
  }
}
var createPerformanceTrace = (name) => {
  const start = (detail) => {
    if (false) {
      try {
        performance.mark(`${name}-start`, {detail});
      } catch {
      }
    }
  };
  const end = (detail) => {
    if (false) {
      try {
        performance.mark(`${name}-end`, {detail});
        performance.measure(name, `${name}-start`, `${name}-end`);
      } catch {
      }
    }
  };
  return {
    start,
    end
  };
};
function exponentialDelay(retryNumber = 0) {
  const increaseFactor = 1500;
  const delay = Math.pow(2, retryNumber) * increaseFactor;
  const randomSum = delay * 0.1 * Math.random();
  return delay + randomSum;
}
function deadlineFromItems(items) {
  const insertCost = items.reduce((acc, item) => acc + item.writeQueryCost, 1);
  const minDeadline = 5;
  const maxDeadline = 90;
  const minCost = 50;
  const maxCost = 1e3;
  const clampedCost = Math.min(maxCost, Math.max(minCost, insertCost));
  const t = (clampedCost - minCost) / (maxCost - minCost);
  return Math.ceil(minDeadline + t * (maxDeadline - minDeadline));
}
function extractRetryAfterFrom(res) {
  return parseInt(res.headers.get("Retry-After") || "2") * 1e3;
}
async function waitMillis(ms) {
  return new Promise((resolve, _) => setTimeout(resolve, ms));
}
function nanoid(size) {
  const url = "_~varfunctio0125634789bdegjhklmpqswxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  size = size || 21;
  let id = "";
  while (0 < size--) {
    id += url[Math.random() * 64 | 0];
  }
  return id;
}
function* eachChunk(totalSize, chunkSize) {
  const [wholes, remainder] = divmod(totalSize, chunkSize);
  for (let i = 0; i < wholes; i++) {
    yield {offset: chunkSize * i, size: chunkSize};
  }
  if (remainder > 0) {
    yield {offset: chunkSize * wholes, size: remainder};
  }
}
function flatten(array) {
  return [].concat(...array);
}
function extractXMLResponseBody(xhr) {
  try {
    if (xhr.readyState == XMLHttpRequest.DONE && xhr.responseXML) {
      const serializer = new XMLSerializer();
      return serializer.serializeToString(xhr.responseXML);
    }
    return "";
  } catch (_) {
    return "";
  }
}
function queryElementFromXML(xml, selector) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, "application/xml");
    return doc.querySelector(selector);
  } catch (_) {
    return null;
  }
}
function safeDebug(fn, args) {
  try {
    fn && fn(...args);
  } catch {
  }
}

// src/wt-storm-client/error-budget.ts
var ErrorBudget = class {
  constructor(maxSimultaneousTasks) {
    this.isTerminalOrExceededError = (e) => {
      if (e.terminal) {
        console.debug(`Error ${e} is terminal, won't retry`);
        return true;
      } else if (this.exceeded) {
        console.debug(`Error budget exceeded: ${this}`);
        return true;
      }
      return false;
    };
    this.nRequests = 0;
    this.nOks = 0;
    this.halt = false;
    this.haltError = null;
    this.maxSimultaneousTasks = maxSimultaneousTasks;
  }
  async wrapPromise(promise) {
    this.registerRequests(1);
    const ret = await promise;
    this.registerOks(1);
    return ret;
  }
  async callWithBookkeeping(asyncRequestingFunction) {
    this.registerRequests(1);
    const returnValue = await asyncRequestingFunction();
    this.registerOks(1);
    return returnValue;
  }
  async withRetries(asyncRequestingFunction) {
    while (true) {
      try {
        return await this.callWithBookkeeping(asyncRequestingFunction);
      } catch (e) {
        if (this.isTerminalOrExceededError(e)) {
          if (e.halt) {
            this.halt = true;
            this.haltError = e;
          }
          throw e;
        } else {
          const nMillis = e.retryAfterMillis || 200;
          console.debug(`Retriable promise rejected with ${e}, waiting ${nMillis}ms and retrying at error budget ${this}`);
          await waitMillis(nMillis);
        }
      }
    }
  }
  async withExponentialRetries(asyncRequestingFunction) {
    const maxRetriesBudget = 20;
    let retryCount = 0;
    while (true) {
      try {
        return await this.callWithBookkeeping(asyncRequestingFunction);
      } catch (e) {
        if (this.isTerminalOrExceededError(e) || retryCount > maxRetriesBudget) {
          if (e.halt) {
            this.halt = true;
            this.haltError = e;
          }
          throw e;
        } else {
          const delay = Math.round(exponentialDelay(retryCount));
          const nMillis = Math.max(e.retryAfterMillis || 2e3, delay);
          retryCount++;
          await waitMillis(nMillis);
        }
      }
    }
  }
  registerRequests(n) {
    this.nRequests += Math.round(n);
  }
  registerOks(n) {
    this.nOks += Math.round(n);
  }
  toString() {
    return `reqs=${this.nRequests} oks=${this.nOks} avail=${this.availabilityRatio.toFixed(2)}`;
  }
  get availabilityRatio() {
    const nIterations = 3;
    const threshold = (this.maxSimultaneousTasks + 1) * nIterations;
    if (this.nRequests < threshold) {
      return 0.999;
    } else {
      return Math.min(0.999, this.nOks / this.nRequests);
    }
  }
  get exceeded() {
    return this.availabilityRatio < 0.9;
  }
};

// src/wt-storm-client/fs-tree.ts
var FSDir = class {
  constructor(name) {
    this.name = name;
    this.children = [];
    this.childNames = new Set();
  }
  toJSON(_key) {
    const orphan = this.parent ? false : true;
    const {name, children} = this;
    return {name, children, orphan};
  }
  get grandparents() {
    if (this.parent) {
      return [this.parent, ...this.parent.grandparents];
    } else {
      return [];
    }
  }
  willAcceptChild(child) {
    const grandparents = this.grandparents;
    if (grandparents.includes(child)) {
      return false;
    }
    return this.childNames.has(child.name);
  }
  get isFile() {
    return false;
  }
  get isDir() {
    return true;
  }
  appendChild(child) {
    if (!this.willAcceptChild(child))
      return false;
    child.parent = this;
    this.children.push(child);
    this.childNames.add(child.name);
    return true;
  }
  childByName(name) {
    return this.children.find((child) => child.name === name) || null;
  }
  get path() {
    if (this.parent) {
      return this.parent.path + "/" + this.name;
    } else {
      return this.name;
    }
  }
  get grandchildren() {
    return this.children.reduce((collected, child) => {
      collected.push(child);
      collected.push(...child.grandchildren);
      return collected;
    }, []);
  }
};
var FSFile = class {
  constructor(name) {
    this.name = name;
  }
  willAcceptChild(_child) {
    return false;
  }
  get isFile() {
    return true;
  }
  get isDir() {
    return false;
  }
  get grandparents() {
    if (this.parent) {
      return [this.parent, ...this.parent.grandparents];
    } else {
      return [];
    }
  }
  appendChild(_child) {
    return false;
  }
  get grandchildren() {
    return [];
  }
  get path() {
    if (this.parent && this.parent.path !== "") {
      return this.parent.path + "/" + this.name;
    } else {
      return this.name;
    }
  }
};
var FileDirectoryConflict = class extends Error {
};
function fromArrayOfItemsWithPaths(fileLikeItems, pathExtractorFn) {
  const root = new FSDir("");
  const inInputOrder = [];
  for (const item of fileLikeItems) {
    let current = root;
    const itemPath = pathExtractorFn(item);
    const pathComponents = itemPath.split("/");
    const overriddenName = pathComponents.pop();
    for (const pathComponent of pathComponents) {
      let subdir = current.childByName(pathComponent);
      if (subdir && subdir.isFile) {
        throw new FileDirectoryConflict(`Found a file while directory expected. Was adding ${itemPath} and tried to add into ${subdir.path}`);
      }
      if (!subdir) {
        subdir = new FSDir(pathComponent);
        current.appendChild(subdir);
      }
      current = subdir;
    }
    const f = new FSFile(overriddenName);
    f.ref = item;
    current.appendChild(f);
    inInputOrder.push(f);
  }
  return [root, inInputOrder];
}

// src/wt-storm-client/parse-jwt.ts
function parseJWT(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(jsonPayload);
}

// src/wt-storm-client/errors.ts
var StormError = class extends Error {
  constructor(message, shortDescription) {
    super(message);
    this.shortDescription = shortDescription;
  }
};
var ErrorWithRetry = class extends StormError {
  constructor(message, retryAfterMillis, shortDescription) {
    super(message, shortDescription);
    this.retryAfterMillis = 2e3;
    this.retryAfterMillis = retryAfterMillis;
  }
};
var TerminalError = class extends Error {
  constructor() {
    super(...arguments);
    this.terminal = true;
    this.halt = false;
    this.shortDescription = "Terminal error";
  }
};
async function handleResponseAndParse(response, onDebug) {
  const statusCode = response.status;
  const responseBody = await response.text();
  if (statusCode >= 200 && statusCode < 300) {
    const parsedResponse = JSON.parse(responseBody);
    safeDebug(onDebug, ["INFO", {...parsedResponse.data}]);
    return parsedResponse;
  }
  if (statusCode == 425) {
    const responsePayload = JSON.parse(responseBody);
    if (responsePayload.error && responsePayload.error.client_action_required) {
      const debugMessage = `Server replied with 425 and told to reupload some blocks`;
      safeDebug(onDebug, ["ERROR", {...responsePayload, shortMessage: debugMessage}]);
      console.debug(debugMessage);
      return responsePayload;
    } else {
      safeDebug(onDebug, ["ERROR", {...responsePayload, shortMessage: `Server replied with 425, still processing`, retryAfter: extractRetryAfterFrom(response)}]);
      throw new ErrorWithRetry(`Server replied with 425, still processing`, extractRetryAfterFrom(response), "425 - Still processing");
    }
  }
  if (statusCode == 429) {
    safeDebug(onDebug, ["ERROR", {shortMessage: `Server throttled with 429, still processing`, retryAfter: extractRetryAfterFrom(response)}]);
    throw new ErrorWithRetry(`Server throttled with ${statusCode}`, extractRetryAfterFrom(response), "429 - Throttled");
  }
  if (statusCode >= 400 && statusCode < 500) {
    safeDebug(onDebug, ["ERROR", {shortMessage: `Server replied with ${statusCode} and said: ${responseBody}`, terminalError: true}]);
    throw new TerminalError(`Server replied with ${statusCode} and said: ${responseBody}`);
  }
  safeDebug(onDebug, ["ERROR", {shortMessage: `Server replied with ${statusCode} and said: ${responseBody}`, retryAfter: extractRetryAfterFrom(response)}]);
  throw new ErrorWithRetry(`Server replied with ${statusCode} - ${responseBody}`, extractRetryAfterFrom(response), "500 - Server error");
}

// src/wt-storm-client/blob-slice.ts
function blobSlice(blob, start, end) {
  if (blob.slice) {
    return blob.slice(start, end);
  } else if (blob.mozSlice) {
    return blob.mozSlice(start, end);
  } else if (blob.webkitSlice) {
    return blob.webkitSlice(start, end);
  } else {
    throw new StormError("No Blob.slice implementation found", "Slice method not found");
  }
}

// src/wt-storm-client/storm-uploader-block.ts
var OPTIMUM_SINGLE_BLOCK_SIZE = 15 * 1024 * 1024;
var BlockState;
(function(BlockState2) {
  BlockState2[BlockState2["NEEDS_CHECKSUM"] = 0] = "NEEDS_CHECKSUM";
  BlockState2[BlockState2["NEEDS_ANNOUNCEMENT"] = 1] = "NEEDS_ANNOUNCEMENT";
  BlockState2[BlockState2["NEEDS_UPLOAD"] = 2] = "NEEDS_UPLOAD";
  BlockState2[BlockState2["UPLOADED"] = 3] = "UPLOADED";
})(BlockState || (BlockState = {}));
function assertProp(inObject, propertyName) {
  if (!inObject.hasOwnProperty(propertyName)) {
    throw new StormError(`${inObject} must have contained ${propertyName}`, "Assertion - property missing");
  }
}
var StormUploaderBlock = class {
  constructor(blob, atOffset, blockSize) {
    this.putRequestHeaders = {};
    this.blob = blob;
    this.blockSize = blockSize;
    this.atOffset = atOffset;
    this.contentMD5 = null;
    this.serverId = null;
    this.presignedPutUrl = null;
    this.putRequestHeaders = {};
    this.mustUploadByMillis = 0;
    this.checksummedBytes = 0;
    this.uploadedBytes = 0;
    this.state = 0;
  }
  static splitBlob(blob) {
    const blockSize = OPTIMUM_SINGLE_BLOCK_SIZE;
    return Array.from(eachChunk(blob.size, blockSize)).map(({offset, size}) => new StormUploaderBlock(blob, offset, size));
  }
  updateAttributesFromServer(serverData) {
    assertProp(serverData, "presigned_put_url");
    this.presignedPutUrl = serverData.presigned_put_url;
    assertProp(serverData, "block_id");
    this.serverId = serverData.block_id;
    assertProp(serverData, "must_upload_in_seconds");
    this.mustUploadByMillis = serverData.must_upload_in_seconds * 1e3 + performance.now();
    assertProp(serverData, "put_request_headers");
    this.putRequestHeaders = serverData.put_request_headers;
    this.state = 2;
  }
  get blobSlice() {
    return blobSlice(this.blob, this.atOffset, this.atOffset + this.blockSize);
  }
};

// src/wt-storm-client/announce-blocks.ts
async function announceBlocks(url, authorizationHeader, idempotencyKey, blocks, onDebug) {
  if (blocks.length === 0)
    return;
  const perfTraceAnnounce = createPerformanceTrace("announceBlock");
  perfTraceAnnounce.start();
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: authorizationHeader,
    "Idempotency-Key": `"${idempotencyKey}"`
  };
  const blockAnnouncements = blocks.map((b) => {
    return {content_length: b.blockSize, content_md5_hex: b.contentMD5};
  });
  const announcementRequest = {blocks: blockAnnouncements};
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(announcementRequest)
  });
  if (response.status === 401) {
    perfTraceAnnounce.end({type: "error"});
    safeDebug(onDebug, [{message: "[POST] /blocks (401)", details: {request: {headers}, statusCode: 401}, type: "ERROR"}]);
    const error = new TerminalError(`Server replied with ${response.status} and said: ${await response.text()}`);
    error.halt = true;
    throw error;
  }
  const responsePayload = await response.json();
  if (responsePayload.data && responsePayload.data.blocks) {
    for (const [i, blockServerData] of responsePayload.data.blocks.entries()) {
      blocks[i].updateAttributesFromServer(blockServerData);
    }
    perfTraceAnnounce.end({type: "announced"});
    return;
  }
  perfTraceAnnounce.end({type: "error"});
  safeDebug(onDebug, [
    {
      message: `[POST] /blocks (${response.status})`,
      details: {request: {headers}, statusCode: response.status, error: responsePayload.error, retryAfter: extractRetryAfterFrom(response)},
      type: "ERROR"
    }
  ]);
  if (response.status >= 400 && response.status < 500 && response.status != 429 && response.status != 425) {
    throw new TerminalError(`Server replied with ${response.status} and said: ${responsePayload.error.message}`);
  }
  throw new ErrorWithRetry(`Block announcement failed - ${responsePayload.error.message}`, extractRetryAfterFrom(response), "Announcement failed");
}

// src/wt-storm-client/upload-block-via-put.ts
var noop = () => {
};
var xmlhttprequestFactory = () => new XMLHttpRequest();
async function uploadBlockViaPut(block, cancelToken, updateProgress = noop, onDebug, xhrFactory = xmlhttprequestFactory) {
  return new Promise((resolve, reject) => {
    const perfTraceUpload = createPerformanceTrace("uploadBlockViaPut");
    perfTraceUpload.start();
    const putRequest = xhrFactory();
    putRequest.upload.addEventListener("abort", () => {
      block.uploadedBytes = 0;
      updateProgress();
      perfTraceUpload.end({
        type: "abort"
      });
      resolve(true);
    });
    putRequest.upload.addEventListener("progress", (progressEvent) => {
      block.uploadedBytes = progressEvent.loaded;
      updateProgress();
      if (cancelToken.canceledOrPaused) {
        putRequest.abort();
      }
    });
    putRequest.addEventListener("error", (progressEvent) => {
      block.uploadedBytes = 0;
      updateProgress();
      perfTraceUpload.end({
        type: "error in PUT request"
      });
      safeDebug(onDebug, [{message: `[PUT] S3 - status [${putRequest.status}]`, type: "ERROR"}]);
      reject(new StormError(`PUT request error - status [${putRequest.status}] - e[${progressEvent.type}: uploading ${progressEvent.loaded}]`, `PUT[${putRequest.status}] failed request`));
    });
    putRequest.addEventListener("load", () => {
      var _a, _b;
      const xmlBody = extractXMLResponseBody(putRequest);
      const errorCode = (_a = queryElementFromXML(xmlBody, "Error > Code")) == null ? void 0 : _a.textContent;
      const errorMessage = (_b = queryElementFromXML(xmlBody, "Error > Message")) == null ? void 0 : _b.textContent;
      if (putRequest.status >= 200 && putRequest.status < 300) {
        block.state = BlockState.UPLOADED;
        perfTraceUpload.end({
          type: "Uploaded"
        });
        resolve(true);
      } else if (putRequest.status === 400 && errorCode === "ExpiredToken" || putRequest.status === 403 && errorCode === "AccessDenied") {
        block.uploadedBytes = 0;
        updateProgress();
        block.state = BlockState.NEEDS_ANNOUNCEMENT;
        perfTraceUpload.end({
          type: errorCode
        });
        const shortDescription = (errorMessage || "") + "\nBlock will need announcement";
        reject(new StormError(`PUT error code: ${errorCode}`, shortDescription));
      } else {
        block.uploadedBytes = 0;
        updateProgress();
        const shortDescription = xmlBody ? `Response body: ${xmlBody}` : "";
        const err = new StormError(`Server responded to PUT with a ${putRequest.status} status`, shortDescription);
        perfTraceUpload.end({
          type: "error in Load"
        });
        reject(err);
      }
    });
    cancelToken.waitUntilResumed().then(() => {
      const perfTraceWait = createPerformanceTrace("waitUntilResumed");
      perfTraceWait.start();
      const now = performance.now();
      if (block.mustUploadByMillis < now) {
        const sec = Math.round((now - block.mustUploadByMillis) / 1e3);
        const warnMessage = `Block upload deadline has lapsed by ${sec} seconds, block has to be reannounced`;
        console.warn(warnMessage);
        safeDebug(onDebug, [{message: warnMessage, type: "INFO"}]);
        block.state = BlockState.NEEDS_ANNOUNCEMENT;
        perfTraceWait.end();
        perfTraceUpload.end({type: "deadline"});
        return resolve(true);
      }
      putRequest.open("PUT", block.presignedPutUrl, true);
      Object.entries(block.putRequestHeaders).forEach(([header, value]) => {
        if (header !== "Content-Length") {
          putRequest.setRequestHeader(header, value);
        }
      });
      putRequest.send(block.blobSlice);
      perfTraceWait.end();
    });
  });
}

// src/wt-storm-client/compute-checksums.ts
var SparkMD5 = __toModule(require_spark_md5());
var CHECKSUM_CHUNK_SIZE = 512 * 1024;
async function readAndAppendByteArray(blob, fileReader, sink) {
  return new Promise((resolve, reject) => {
    fileReader.onerror = reject;
    fileReader.onload = () => {
      sink(fileReader.result);
      resolve(true);
    };
    fileReader.readAsArrayBuffer(blob);
  });
}
async function computeChecksums(block, cancelToken, updateProgress) {
  const perfTraceCompute = createPerformanceTrace("computeChecksums");
  perfTraceCompute.start();
  const fileReader = new FileReader();
  const spark = new SparkMD5.ArrayBuffer();
  const blob = block.blobSlice;
  const sink = spark.append.bind(spark);
  block.checksummedBytes = 0;
  for (const {offset, size} of eachChunk(blob.size, CHECKSUM_CHUNK_SIZE)) {
    cancelToken.throwIfCanceled();
    const chunk = blobSlice(blob, offset, offset + size);
    await readAndAppendByteArray(chunk, fileReader, sink);
    block.checksummedBytes = offset + size;
    updateProgress();
  }
  block.contentMD5 = spark.end(false);
  block.state = BlockState.NEEDS_ANNOUNCEMENT;
  perfTraceCompute.end();
}

// src/wt-storm-client/run-upload-iteration.ts
function takeInState(fromBlocks, havingState, takeN) {
  const r = [];
  for (const b of fromBlocks) {
    if (r.length == takeN)
      break;
    if (b.state === havingState) {
      r.push(b);
    }
  }
  return r;
}
async function runUploadIteration(announceBlocksUrl, authorizationHeader, parallelStreams, blocks, cancelToken, errorBudget, updateProgress, idempotencyKey, onDebug) {
  const tasks = [];
  const blocksToUpload = takeInState(blocks, BlockState.NEEDS_UPLOAD, parallelStreams);
  const uploadPromises = blocksToUpload.map((b) => errorBudget.wrapPromise(uploadBlockViaPut(b, cancelToken, updateProgress, onDebug)));
  tasks.push(...uploadPromises);
  const blocksToAnnounce = takeInState(blocks, BlockState.NEEDS_ANNOUNCEMENT, parallelStreams);
  tasks.push(errorBudget.withRetries(() => announceBlocks(announceBlocksUrl, authorizationHeader, idempotencyKey, blocksToAnnounce, onDebug)));
  const blocksToChecksum = takeInState(blocks, BlockState.NEEDS_CHECKSUM, parallelStreams);
  const checksumPromises = blocksToChecksum.map((b) => errorBudget.wrapPromise(computeChecksums(b, cancelToken, updateProgress)));
  tasks.push(...checksumPromises);
  const results = await Promise.allSettled(tasks);
  const rejectionReasons = results.filter((r) => r.status === "rejected").map((r) => r.reason);
  if (errorBudget.exceeded) {
    if (rejectionReasons.length > 0) {
      const firstError = rejectionReasons[0];
      if (firstError instanceof Error) {
        throw firstError;
      } else if (typeof firstError === "string") {
        throw new StormError(firstError, firstError);
      } else {
        throw new StormError(stringifyEvent(firstError), typeof firstError);
      }
    } else {
      throw new StormError(`Error bugdet exceeded - ${errorBudget}`, "Budget exceeded");
    }
  }
  return blocks.filter((block) => BlockState.UPLOADED !== block.state);
}

// src/wt-storm-client/storm-batch-items.ts
var EmptyDirectory = class {
  constructor(path) {
    this.path = path;
  }
  get itemType() {
    return "empty_directory";
  }
  get uploadProgress() {
    const bogusSize = this.path.toString().length;
    return {total: bogusSize, checksummed: bogusSize, uploaded: bogusSize};
  }
  get writeQueryCost() {
    return 2;
  }
  get includedInFinalizationRequests() {
    return true;
  }
  toFinalizationRequest() {
    return {
      path: this.path,
      item_type: "empty_directory"
    };
  }
  toPreflightRequest() {
    return {
      path: this.path,
      item_type: "empty_directory"
    };
  }
};
var Link = class {
  constructor(title, url) {
    this.title = title;
    this.url = url;
  }
  toFinalizationRequest() {
    return {
      url: this.url,
      item_type: "link",
      title: this.title ? this.title : null
    };
  }
  get uploadProgress() {
    const bogusSize = this.url.toString().length + this.title.toString().length;
    return {total: bogusSize, checksummed: bogusSize, uploaded: bogusSize};
  }
  get writeQueryCost() {
    return 1;
  }
  get itemType() {
    return "link";
  }
  get includedInFinalizationRequests() {
    return true;
  }
};
var StormUploaderFile = class {
  constructor(path, blob) {
    this.path = path;
    this.blob = blob;
    this.size = blob.size;
    this.blocks = StormUploaderBlock.splitBlob(blob);
  }
  get itemType() {
    return "file";
  }
  get name() {
    return this.path.split("/")[0];
  }
  get writeQueryCost() {
    return 3 + this.blocks.length * 2;
  }
  get uploadProgress() {
    const initial = {uploaded: 0, checksummed: 0, total: this.size};
    this.blocks.forEach((block) => {
      initial.uploaded += block.uploadedBytes;
      initial.checksummed += block.checksummedBytes;
    });
    return initial;
  }
  toFinalizationRequest() {
    return {
      path: this.path,
      item_type: "file",
      block_ids: this.blocks.map((block) => block.serverId)
    };
  }
  get includedInFinalizationRequests() {
    return true;
  }
  toPreflightRequest() {
    return {
      path: this.path,
      item_type: "file",
      blocks: this.blocks.map((block) => {
        return {content_length: block.blockSize};
      })
    };
  }
};
var SuppressedFile = class extends StormUploaderFile {
  constructor(path, blob) {
    super(path, blob);
    this.blocks = [];
  }
  get uploadProgress() {
    return {uploaded: this.size, checksummed: this.size, total: this.size};
  }
  get includedInFinalizationRequests() {
    return false;
  }
  get writeQueryCost() {
    return 0;
  }
  toFinalizationRequest() {
    throw new StormError(`${this} may not be included in finalization requests`, "Potential missing file");
  }
};
function extractPath(file) {
  return file.overriddenRelativePath || file.webkitRelativePath || file.name;
}
function prepareItemsForUpload(items) {
  const internalItems = items.map((item) => {
    if (item instanceof File) {
      const path = extractPath(item);
      if (item.name === ".DS_Store" || item.name.endsWith("/.DS_Store")) {
        return new SuppressedFile(path, item);
      } else {
        return new StormUploaderFile(path, item);
      }
    } else if (item instanceof EmptyDirectory) {
      return item;
    } else if (item.hasOwnProperty("url")) {
      return new Link(item.title, item.url);
    } else {
      throw new StormError(`Unrecognized item given to upload: ${item}`, "Unrecognized item");
    }
  });
  const domFiles = items.filter((item) => item instanceof File);
  const [fileTree, _] = fromArrayOfItemsWithPaths(domFiles, (f) => extractPath(f));
  const onlyFiles = internalItems.filter((e) => e.itemType == "file").map((e) => e);
  return [internalItems, onlyFiles, fileTree];
}

// src/wt-storm-client/finalize-batch.ts
var SOME_BLOCKS_INVALIDATED = "some_blocks_invalidated";
function invalidateBlocks(uploaderFiles, invalidBlockIds) {
  const perServerId = {};
  uploaderFiles.map((fe) => fe.blocks.map((b) => b.serverId && (perServerId[b.serverId] = b)));
  for (const id of invalidBlockIds) {
    if (perServerId[id]) {
      perServerId[id].state = BlockState.NEEDS_UPLOAD;
    }
  }
}
async function performAppendToBatchRequest(mutationToken, atPosition, url, authorizationHeader, idempotencyKey, uploaderItems, errorBudget, baseVersion) {
  const items = uploaderItems.filter((entry) => entry.includedInFinalizationRequests).map((entry) => entry.toFinalizationRequest());
  const headers = {
    Accept: "application/json",
    Authorization: authorizationHeader,
    "Content-Type": "application/json",
    "Idempotency-Key": `"${idempotencyKey}"`,
    "X-Error-Budget": errorBudget.toString(),
    "X-Deadline": deadlineFromItems(uploaderItems).toString()
  };
  const mutateBatchRequestPayload = {
    operation: "append",
    at_position: atPosition,
    mutation_token: mutationToken,
    items
  };
  if (baseVersion)
    mutateBatchRequestPayload["base_version"] = baseVersion;
  const response = await fetch(url, {
    method: "PATCH",
    headers,
    body: JSON.stringify(mutateBatchRequestPayload)
  });
  const responsePayload = await handleResponseAndParse(response);
  if (responsePayload.error && responsePayload.error.client_action_required && responsePayload.error.pending_block_ids) {
    const justFiles = uploaderItems.filter((e) => e.itemType == "file");
    invalidateBlocks(justFiles, responsePayload.error.pending_block_ids);
    return SOME_BLOCKS_INVALIDATED;
  }
  return responsePayload;
}
async function performRemoveFromBatchRequest(mutationToken, itemIds, url, authorizationHeader, idempotencyKey, errorBudget, baseVersion) {
  const headers = {
    Accept: "application/json",
    Authorization: authorizationHeader,
    "Content-Type": "application/json",
    "Idempotency-Key": `"${idempotencyKey}"`,
    "X-Error-Budget": errorBudget.toString(),
    "X-Deadline": "5"
  };
  const items = itemIds.map((itemId) => {
    return {id: itemId};
  });
  const delMutateBatchRequestPayload = {
    operation: "remove",
    items,
    mutation_token: mutationToken
  };
  if (baseVersion)
    delMutateBatchRequestPayload["base_version"] = baseVersion;
  const response = await fetch(url, {
    method: "PATCH",
    headers,
    body: JSON.stringify(delMutateBatchRequestPayload)
  });
  return await handleResponseAndParse(response);
}
async function performCreateBatchRequest(url, authorizationHeader, idempotencyKey, uploaderItems, errorBudget, onDebug) {
  const perfTraceBatch = createPerformanceTrace("performCreateBatchRequest");
  perfTraceBatch.start();
  const items = uploaderItems.filter((entry) => entry.includedInFinalizationRequests).map((entry) => entry.toFinalizationRequest());
  const batchContents = {items};
  const headers = {
    Accept: "application/json",
    Authorization: authorizationHeader,
    "Content-Type": "application/json",
    "Idempotency-Key": `"${idempotencyKey}"`,
    "X-Error-Budget": errorBudget.toString(),
    "X-Deadline": deadlineFromItems(uploaderItems).toString()
  };
  safeDebug(onDebug, [
    {
      message: "[POST] /batch",
      type: "INFO",
      details: {
        ...headers
      }
    }
  ]);
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(batchContents)
  });
  const responseDebug = (type, details) => onDebug && onDebug({message: `${type}: [POST] /batch `, details: {...details, statusCode: response.status}, type});
  const responsePayload = await handleResponseAndParse(response, responseDebug);
  if (responsePayload.error && responsePayload.error.client_action_required && responsePayload.error.pending_block_ids) {
    const justFiles = uploaderItems.filter((e) => e.itemType == "file");
    invalidateBlocks(justFiles, responsePayload.error.pending_block_ids);
    perfTraceBatch.end({type: "invalidation"});
    return SOME_BLOCKS_INVALIDATED;
  }
  perfTraceBatch.end({type: "success"});
  return responsePayload;
}
async function preflightBatch(url, token, uploaderFiles, onDebug) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
  const items = uploaderFiles.map((entry) => entry.toPreflightRequest());
  const req = {items};
  safeDebug(onDebug, [{message: "[POST] /preflight", details: {headers, body: req}}]);
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(req)
  });
  const responseDebug = (type, details) => onDebug && onDebug({message: `${type}: [POST] /preflight `, details, type});
  return await handleResponseAndParse(response, responseDebug);
}

// src/wt-storm-client.ts
var SIMULTANEOUS_UPLOADS = 5;
var DEFAULT_DELAY_BATCHES_MUTATION = 1;
function prepareStormUploadAndCreateBatch(options) {
  const {items, token} = options;
  const [uploaderItems, uploaderFiles, fileTree] = prepareItemsForUpload(items);
  const tokenClaims = parseJWT(token);
  const announceBlockUrl = tokenClaims["storm.announce_blocks_url"];
  const createBatchUrl = tokenClaims["storm.create_batch_url"];
  const preflightBatchUrl = tokenClaims["storm.preflight_batch_url"];
  const runUploadIterationFn = options.runUploadIterationFn || runUploadIteration;
  const performCreateBatchRequestFn = options.performCreateBatchRequestFn || performCreateBatchRequest;
  const errorBudget = new ErrorBudget(SIMULTANEOUS_UPLOADS);
  const cancelToken = new CancelToken();
  const statsFn = () => {
    return {errorBudget: errorBudget.toString(), cancelTokenState: cancelToken.state};
  };
  const allBlocks = flatten(uploaderFiles.map((entry) => entry.blocks));
  const totalUploadSize = sum(allBlocks.map((b) => b.blockSize));
  const idempotencyKey = nanoid(64);
  const updateProgress = getProgressFnc(options, uploaderFiles, totalUploadSize, errorBudget);
  const startUploadAsync = getStartUploadAsyncFn(createBatchUrl, preflightBatchUrl, announceBlockUrl, runUploadIterationFn, uploaderItems, uploaderFiles, errorBudget, cancelToken, updateProgress, idempotencyKey, token, allBlocks, {
    type: "create",
    performCreateBatchRequestFn
  }, options.onDebug);
  return {
    start: startUploadAsync,
    cancel: cancelToken.cancel.bind(cancelToken),
    pause: cancelToken.pause.bind(cancelToken),
    resume: cancelToken.resume.bind(cancelToken),
    fileTree,
    getStats: statsFn
  };
}
function removeItemsFromBatch(options) {
  const {token} = options;
  const {batchForeignId, batchForeignSystem, mutationToken, baseVersion, itemIds} = options;
  const tokenClaims = parseJWT(token);
  const createBatchUrl = tokenClaims["storm.create_batch_url"];
  const mutationUrl = new URL(createBatchUrl);
  mutationUrl.searchParams.set("foreign_id", batchForeignId);
  mutationUrl.searchParams.set("foreign_system", batchForeignSystem);
  const mutateBatchUrl = mutationUrl.toString();
  const errorBudget = new ErrorBudget(SIMULTANEOUS_UPLOADS);
  const cancelToken = new CancelToken();
  const statsFn = () => {
    return {errorBudget: errorBudget.toString(), cancelTokenState: cancelToken.state};
  };
  const idempotencyKey = nanoid(64);
  const startUploadAsync = async () => {
    return await errorBudget.withRetries(() => performRemoveFromBatchRequest(mutationToken, itemIds, mutateBatchUrl, `Bearer ${token}`, idempotencyKey, errorBudget, baseVersion));
  };
  return {
    start: startUploadAsync,
    cancel: cancelToken.cancel.bind(cancelToken),
    pause: cancelToken.pause.bind(cancelToken),
    resume: cancelToken.resume.bind(cancelToken),
    fileTree: new FSDir("/"),
    getStats: statsFn
  };
}
function prepareStormUploadAndAppendToBatch(options, skipPreflightReq) {
  const {items, token} = options;
  const [uploaderItems, uploaderFiles, fileTree] = prepareItemsForUpload(items);
  const {batchForeignId, batchForeignSystem, mutationToken, baseVersion, atPosition} = options;
  const tokenClaims = parseJWT(token);
  const announceBlockUrl = tokenClaims["storm.announce_blocks_url"];
  const runUploadIterationFn = options.runUploadIterationFn || runUploadIteration;
  const performAppendToBatchRequestFn = options.performAppendToBatchRequestFn || performAppendToBatchRequest;
  const createBatchUrl = tokenClaims["storm.create_batch_url"];
  const preflightBatchUrl = tokenClaims["storm.preflight_batch_url"];
  const mutationUrl = new URL(createBatchUrl);
  mutationUrl.searchParams.set("foreign_id", batchForeignId);
  mutationUrl.searchParams.set("foreign_system", batchForeignSystem);
  const mutateBatchUrl = mutationUrl.toString();
  const errorBudget = new ErrorBudget(SIMULTANEOUS_UPLOADS);
  const cancelToken = new CancelToken();
  const statsFn = () => {
    return {errorBudget: errorBudget.toString(), cancelTokenState: cancelToken.state};
  };
  const allBlocks = flatten(uploaderFiles.map((entry) => entry.blocks));
  const totalUploadSize = sum(allBlocks.map((b) => b.blockSize));
  const idempotencyKey = nanoid(64);
  const updateProgress = getProgressFnc(options, uploaderFiles, totalUploadSize, errorBudget);
  const startUploadAsync = getStartUploadAsyncFn(mutateBatchUrl, preflightBatchUrl, announceBlockUrl, runUploadIterationFn, uploaderItems, uploaderFiles, errorBudget, cancelToken, updateProgress, idempotencyKey, token, allBlocks, {
    type: "append",
    mutationToken,
    baseVersion,
    atPosition,
    skipPreflightReq,
    performAppendBatchRequestFn: performAppendToBatchRequestFn
  }, options.onDebug);
  return {
    start: startUploadAsync,
    cancel: cancelToken.cancel.bind(cancelToken),
    pause: cancelToken.pause.bind(cancelToken),
    resume: cancelToken.resume.bind(cancelToken),
    fileTree,
    getStats: statsFn
  };
}
var ProgressWeights = class {
  static get upload() {
    return this._upload;
  }
  static set upload(val) {
    this.updateValues(val, "upload");
  }
  static get checksum() {
    return this._checksum;
  }
  static set checksum(val) {
    this.updateValues(val, "checksum");
  }
  static updateValues(val, attr) {
    if (val < 0 || val > 100) {
      console.log("ProgressWeights: only accept values between [0 and 100]");
      return;
    }
    if (attr === "upload") {
      this._upload = val;
      this._checksum = 100 - val;
    } else {
      this._checksum = val;
      this._upload = 100 - val;
    }
  }
};
ProgressWeights._checksum = 1;
ProgressWeights._upload = 99;
function calcProgress(uploaded, checksummed, total) {
  const floatValue = (uploaded * ProgressWeights.upload + checksummed * ProgressWeights.checksum) / total / 100;
  return Math.round((floatValue + Number.EPSILON) * 100) / 100;
}
function getProgressFnc(options, uploaderFiles, totalUploadSizeInBytes, errorBudget) {
  const {onProgress: uploadProgressCallback} = options;
  if (!uploadProgressCallback)
    return () => {
    };
  return () => {
    let checksummedAcrossEntireUpload = 0;
    let uploadedAcrossEntireUpload = 0;
    const perFile = uploaderFiles.map((uf) => {
      let checksummed = 0;
      let uploaded = 0;
      for (const block of uf.blocks) {
        checksummedAcrossEntireUpload += block.checksummedBytes;
        uploadedAcrossEntireUpload += block.uploadedBytes;
        checksummed += block.checksummedBytes;
        uploaded += block.uploadedBytes;
      }
      return {
        checksummed,
        uploaded,
        total: uf.size,
        progress: calcProgress(uploaded, checksummed, uf.size)
      };
    });
    const progress = {
      uploaded: uploadedAcrossEntireUpload,
      checksummed: checksummedAcrossEntireUpload,
      total: totalUploadSizeInBytes,
      perFile,
      progress: calcProgress(uploadedAcrossEntireUpload, checksummedAcrossEntireUpload, totalUploadSizeInBytes)
    };
    errorBudget.registerRequests(1);
    uploadProgressCallback(progress);
    errorBudget.registerOks(1);
  };
}
function getStartUploadAsyncFn(createOrMutateBatchUrl, preflightBatchUrl, announceBlockUrl, runUploadIterationFn, uploaderItems, uploaderFiles, errorBudget, cancelToken, updateProgress, idempotencyKey, token, allBlocks, action, onDebug) {
  return async () => {
    var _a, _b;
    function actionRequestFn(action2, url, bearerTokenString, idempotencyKey2, uploaderItems2, errorBudget2) {
      if (action2.type === "create") {
        if (!action2.performCreateBatchRequestFn) {
          throw new Error("performCreateBatchRequestFn is required for create action");
        }
        return action2.performCreateBatchRequestFn(url, bearerTokenString, idempotencyKey2, uploaderItems2, errorBudget2, onDebug);
      } else {
        const {mutationToken, baseVersion, atPosition, performAppendBatchRequestFn} = action2;
        if (!mutationToken || !performAppendBatchRequestFn) {
          throw new Error("mutationToken and performAppendBatchRequestFn are required for append action");
        }
        return performAppendBatchRequestFn(mutationToken, atPosition || 0, url, bearerTokenString, idempotencyKey2, uploaderItems2, errorBudget2, baseVersion);
      }
    }
    let batchSettings = null;
    if (!action.skipPreflightReq) {
      batchSettings = await errorBudget.withRetries(() => preflightBatch(preflightBatchUrl, token, uploaderFiles, onDebug));
    }
    if (allBlocks.length == 0) {
      const response = await errorBudget.withExponentialRetries(() => actionRequestFn(action, createOrMutateBatchUrl, `Bearer ${token}`, idempotencyKey, uploaderItems, errorBudget));
      return response;
    }
    let remainingBlocks = allBlocks;
    let responseToReturn = {ok: false};
    while (remainingBlocks.length > 0) {
      if (errorBudget.exceeded) {
        safeDebug(onDebug, [{message: `Too many errors: ${errorBudget} -Budget exceeded`, type: "ERROR"}]);
        throw new StormError(`Too many errors: ${errorBudget}`, "Budget exceeded");
      }
      if (errorBudget.halt) {
        safeDebug(onDebug, [{message: `Upload process halted - This is due to a fatal error.
Error: ${(_a = errorBudget.haltError) == null ? void 0 : _a.message}`, type: "ERROR"}]);
        throw new StormError("Upload process halted", `This is due to a fatal error.
Error: ${(_b = errorBudget.haltError) == null ? void 0 : _b.message}`);
      }
      if (cancelToken.canceled) {
        throw new Error(`Canceled via token`);
      }
      remainingBlocks.sort((a, b) => b.blockSize - a.blockSize);
      remainingBlocks = await runUploadIterationFn(announceBlockUrl, `Bearer ${token}`, SIMULTANEOUS_UPLOADS, remainingBlocks, cancelToken, errorBudget, updateProgress, idempotencyKey, onDebug);
      if (remainingBlocks.length > 0) {
        continue;
      }
      const {data: batchData} = batchSettings || {};
      const {batch_mutation_settings: mutSettings} = batchData || {};
      const initialDelay = mutSettings && mutSettings.initial_delay !== void 0 ? mutSettings.initial_delay : DEFAULT_DELAY_BATCHES_MUTATION;
      await waitMillis(initialDelay * 1e3);
      const outcome = await errorBudget.withExponentialRetries(() => actionRequestFn(action, createOrMutateBatchUrl, `Bearer ${token}`, idempotencyKey, uploaderItems, errorBudget));
      if (outcome === SOME_BLOCKS_INVALIDATED) {
        remainingBlocks = allBlocks;
      } else {
        responseToReturn = outcome;
        break;
      }
    }
    return responseToReturn;
  };
}
export {
  Link,
  ProgressWeights,
  calcProgress,
  prepareStormUploadAndAppendToBatch,
  prepareStormUploadAndCreateBatch,
  removeItemsFromBatch
};
//# sourceMappingURL=wt-storm-client.esm.bundle.js.map
